import { SupportedLanguages } from '@/i18n/config'

interface MetaInfo {
  title: string
}

export const defaultTitlePrefix = 'Kolr - '

const defaultMetaInfo: { [key in SupportedLanguages]: MetaInfo } = {
  [SupportedLanguages.zhTW]: {
    title: 'AI 網紅行銷解決方案專家',
  },
  [SupportedLanguages.enUS]: {
    title: 'Expert of AI Influencer Marketing Solutions',
  },
  [SupportedLanguages.ja]: {
    title: '最適なインフルエンサーがすぐ見つかる検索ツール',
  },
  [SupportedLanguages.ach]: {
    title: 'Expert of AI Influencer Marketing Solutions',
  },
}

export default defaultMetaInfo
